// src/components/MonthFilter.js
import React from 'react'
import { Calendar, Filter } from 'lucide-react'

const MonthFilter = ({ transactions, selectedMonth, onMonthChange }) => {
  // Obtener todos los meses únicos de las transacciones
  const getAvailableMonths = (transactions) => {
    const months = new Set()
    
    transactions.forEach(transaction => {
      const date = new Date(transaction.transaction_date)
      const monthKey = `${date.getFullYear()}-${date.getMonth()}`
      const monthName = date.toLocaleDateString('es-ES', {
        month: 'long',
        year: 'numeric'
      })
      
      months.add({
        key: monthKey,
        name: monthName.charAt(0).toUpperCase() + monthName.slice(1),
        date: date
      })
    })
    
    // Convertir Set a Array y ordenar por fecha
    return Array.from(months).sort((a, b) => b.date - a.date)
  }

  const availableMonths = getAvailableMonths(transactions)

  return (
    <div className="bg-white rounded-lg shadow p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Filter className="h-5 w-5 text-gray-600" />
          <h3 className="text-lg font-medium text-gray-900">Filtrar por mes</h3>
        </div>
        
        <div className="flex items-center space-x-3">
          <select
            value={selectedMonth || 'all'}
            onChange={(e) => onMonthChange(e.target.value === 'all' ? null : e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="all">Todos los meses</option>
            {availableMonths.map((month) => (
              <option key={month.key} value={month.key}>
                {month.name}
              </option>
            ))}
          </select>
          
          <Calendar className="h-5 w-5 text-gray-400" />
        </div>
      </div>
      
      {selectedMonth && (
        <div className="mt-3 text-sm text-gray-600">
          Mostrando transacciones de: <span className="font-medium">
            {availableMonths.find(m => m.key === selectedMonth)?.name}
          </span>
        </div>
      )}
    </div>
  )
}

export default MonthFilter